import { useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '@api'
import { showSuccessToast } from '@utils'
import { useLanguage } from '@context'

interface DeleteAlbumParams {
  id: string
}

const deleteAlbum = async ({ id }: DeleteAlbumParams): Promise<void> => {
  await api.delete(`/albums/${id}`)
}

export const useDeleteAlbum = () => {
  const queryClient = useQueryClient()
  const { t } = useLanguage()

  return useMutation<void, Error, DeleteAlbumParams>({
    mutationFn: deleteAlbum,
    onSuccess: async () => {
      showSuccessToast(t('toast.success'), t('toast.albumDeleted'))
      await queryClient.invalidateQueries({ queryKey: ['albums'] })
    },
  })
}
